import React, {useEffect, useState} from 'react';
import {ISyntheticEvent, SnippetTheme} from './Helpers/Types';
import {TextField} from '@material-ui/core';
import {useStyleContext} from "./Utils/UseStyleContext";

type TextFieldProps = {
    id: string,
    value: string,
    label: string,
    getValue?: (value: string) => void,
    handleChange?: (fieldName: string, value: string) => void,
    required?: boolean,
    disabled?: boolean,
    placeholder?: string,
    invalid?: any
    maxLength?: number
}

export default function TextInput(props: TextFieldProps) {
    const [value, setValue] = useState(props.value);
    // @ts-ignore
    const {theme} = useStyleContext();

    useEffect(() => {
        setValue(props.value);
    }, [props.value])

    const handleChange = (event: ISyntheticEvent) => {
        event.preventDefault();
        let value = event.target.value;
        setValue(value);
        props.getValue?.(value);
        props.handleChange?.(props.id, value);
    };

    // @ts-ignore
    const handleEmailKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
        console.log("keydown")
        if (e.key === ' ') e.preventDefault()
    }

    // @ts-ignore
    const handleEmailPaste = (e: ClipboardEvent<HTMLInputElement>): void => {
        if (e.clipboardData.getData('text').trim() === '') e.preventDefault()
    }

    switch (theme) {
        case SnippetTheme.MaterialUI:
            return (
                <TextField
                    style={{marginTop: '5px', marginBottom: '5px'}}
                    id={props.id}
                    label={props.label}
                    value={value}
                    required={props.required ? props.required : false}
                    onChange={handleChange}
                    disabled={props.disabled === true}
                    placeholder={props.placeholder ?? ''}
                    className={props.invalid === true ? 'bLoyal-invalid-input' : ''}
                    error={props.invalid === true}
                    onKeyDown={handleEmailKeyDown}
                    onPaste={handleEmailPaste}
                    inputProps={{maxLength: props.maxLength}}
                />
            );
        default:
            return <label className={props.invalid === true ? 'bLoyal-invalid-label' : ''}>{props.label + (props.required ? "* " : " ")}
                <input style={{width: '100%'}} type="text" id={props.id} onChange={handleChange}
                       required={props.required} disabled={props.disabled === true} value={value}
                       placeholder={props.placeholder ?? ''} className={props.invalid === true ? 'bLoyal-invalid-input' : ''} maxLength={props.maxLength}/>
            </label>
    }
}